import { render } from "./Cardbox.vue?vue&type=template&id=1dbe7560"
import script from "./Cardbox.vue?vue&type=script&lang=js"
export * from "./Cardbox.vue?vue&type=script&lang=js"

import "./Cardbox.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/runner/work/less-mess/less-mess/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__